import PageTabPanel, { PageTabType } from './PageTabPanel'
import RoutesTabPanel, { RoutesTabPanelType } from './RoutesTabPanel'

export default PageTabPanel
export type { PageTabType, RoutesTabPanelType }
export { RoutesTabPanel }
